/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var BedIcon = createIcon({
  name: 'BedIcon',
  height: 512,
  width: 640,
  svgPath: 'M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default BedIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/bed-icon.js
// module id = 376
// module chunks = 0